import React, { useState, useEffect } from "react";
import "./Notification.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { fetchNotification } from "../../services/api";
import { popupnotification } from "../../assets/static/popupNotification";
import { updateNotification } from "../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import FaqNav from "../../components/FAQ/FaqNav";
import NoResultsComponent from "../../components/NoResults/NoResult";
import Loader from "../../components/Loader/Loader";
import moment from "moment-timezone";

import { useLanguage } from "../../context/Languagecontext";
const Notifications = () => {
  const { Globals ,languages} = useLanguage();
  const [notificationsCount, setNotificationsCount] = useState("0");
  const [todaynotifications, setTodayNotifications] = useState([]);
  const [oldernotifications, setOlderNotifications] = useState([]);
  const [contentDataStatus, setContentDataStatus] = useState(null);
  const [filter, setFilter] = useState("all");
  const [data, setData] = useState([]);
  const moment = require("moment-timezone");

  const getData = async () => {
      try {
        // Uncomment these lines if you need to fetch notifications from an API.
        const result = await fetchNotification(
          Globals.ENDPOINT.NOTIFICATION_PAGE_DATA,
          "All",
          Globals.NOTIFICATION_LIMIT
        );
        setData(result?.content?.notifications);
        filterNotifications2(result?.content?.notifications);
        setNotificationsCount(result?.content?.unreadCount);
        setContentDataStatus(result.status);
      } catch (error) {
        setContentDataStatus("Error");
        console.error("Error in App component:", error);
      }
    };

  useEffect(() => {
    getData();
  }, []);

  useEffect(()=>{
    getData();
  },[languages]);

  const unreadCount = data.filter((notification) => notification.read === false).length;

  const filteredNotifications = async (type) => {
    setFilter(type);
    const result = await fetchNotification(
      Globals.ENDPOINT.NOTIFICATION_PAGE_DATA,
      type,
      Globals.NOTIFICATION_LIMIT
    );
    setData(result?.content?.notifications);
    filterNotifications2(result?.content?.notifications);
    setNotificationsCount(result?.content?.unreadCount);
  };

  function filterNotifications2(notifications) {
    const today = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");
    const todayNotifications = [];
    const olderNotifications = [];

    notifications?.map((notification) => {
      const notificationDate = new Date(notification.createdAt);
      const formattedDate = moment(notificationDate).tz("Asia/Kolkata").format("YYYY-MM-DD");
      if (formattedDate === today) {
        todayNotifications.push(notification);
      } else {
        olderNotifications.push(notification);
      }
    });

    setTodayNotifications(todayNotifications);
    setOlderNotifications(olderNotifications);
  }
  const getNotificationById = (id) => {
    return data.find((notification) => notification.notificationId === id);
  };
  const updateNotification1 = async (id, read) => {
    try {
      const response = await updateNotification(Globals.ENDPOINT.UPDATENOTIFICATION, id, read);
      filteredNotifications(filter);
    } catch (error) {
      console.error("Error in App component:", error);
    }
  };
  function handleUpdateUnreadNotification(id) {
    const notification = getNotificationById(id);
    if (notification) {
      updateNotification1(id, true);
    } else {
      console.log(`Notification with ID: ${id} not found.`);
    }
  }

  const dateFunct = (inp) => {
    const date = new Date(inp);
    const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: false };
    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

    const options = {
      hour: "2-digit",
      minute: "2-digit",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour12: false,
    };

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    return ` ${ formattedTime}, ${day} ${month} ${year}`;
  
    // const formattedDate = date.toLocaleString('en-US', options).split(', ');
  
    // return `${ formattedTime}, ${formattedDate[0]} ${formattedDate[1]}`;
  }
  const location = useLocation();
  let parentName = location.state?.activeHeader;
  const [NavLinkState, setNav] = useState ({
    FirstNavbar:"",
    SecondNavbar: Globals.NOTIFICATIONS,
    Title: Globals.NOTIFICATIONS,
    ParentTab: parentName,
  });

  useEffect(() => {
    if(parentName === "internal_dashboard" || parentName === "dashboard" || parentName === "admin") {
      parentName = "Dashboard"
    } else if (parentName === "requests") {
      parentName = "Requests"
    } else if (parentName === "auditTrails") {
      parentName = "Audit Trails"
    } else if (parentName === "internal_management") {
      parentName = "Internal Management"
    } else {
      parentName === 'proposals' ? parentName = "My Proposals" : parentName = "All Proposals";
    }
    setNav(nav => ({
      ...nav,
      FirstNavbar: parentName
    }));
  }, [])

return (
    <div className="Background-Page">
      <Header notificationsLength={notificationsCount} route="Notification"/>
      <FaqNav props={NavLinkState}/>

      <div className="Main">
        <div className="notification-container-Wrapper">
          <div className="filter-buttons">
            <div className="Notification-Horizontonal">
              <button
                onClick={() => filteredNotifications("all")}
                className={filter === "all" ? "Notificationactive" : ""}
              >
                {Globals.DASHBOARD.ALL}
              </button>
              <button
                onClick={() => filteredNotifications("unread")}
                className={filter === "unread" ? "Notificationactive" : ""}
              >
                {Globals.DASHBOARD.UNREAD} ({notificationsCount})
              </button>
              <button
                onClick={() => filteredNotifications("read")}
                className={filter === "read" ? "Notificationactive" : ""}
              >
                {Globals.DASHBOARD.READ}
              </button>
            </div>
          </div>

          {data.length ? (
            <div style={{ margin: "10px", paddingBottom: "20px" }}>
              {["Today", "Older"].map((item) => {
                const notificationsToDisplay =
                  item === "Today" ? todaynotifications : oldernotifications;

                return (
                  <>
                    {notificationsToDisplay.length !== 0 && (
                      <>
                        <h6
                          className="notification-content"
                          style={{ marginLeft: "15px", fontSize: "16px", fontWeight: "600" }}
                        >
                          {item === "Today" ? Globals.NOTIFICATIONHEADER.TODAY : Globals.NOTIFICATIONHEADER.OLDER}
                        </h6>
                        <div className="notification-container">
                          {notificationsToDisplay.map((notification) => (
                            <div
                              className={`${
                                notification.read ? "read" : "unread"
                              } notification-items`}
                              key={notification.id}
                              onClick={(e) => {
                                if (e.currentTarget.classList.contains("unread")) {
                                  handleUpdateUnreadNotification(notification.notificationId);
                                }
                              }}
                            >
                              <div className="notification-content">
                                <h6 style={{ fontSize: "14px" }}>{notification.message}</h6>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    color: "var(--text-secondary, #5c5c5d)",
                                  }}
                                >
                                  {notification.subMessage}
                                </p>
                              </div>
                              <div className="notification-date">
                                <span
                                  style={{ fontSize: "12px", color: "black", fontWeight: "400" }}
                                >
                                  {dateFunct(notification.createdAt)}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </>
                );
              })}
            </div>
          ) : contentDataStatus && contentDataStatus?.length > 0 ? (
            <>
              <>
                <NoResultsComponent
                  data={{ message: Globals.NO_DATA, img: Globals.NO_DATA_FOUND_IMG }}
                />
              </>
            </>
          ) : (
            <div className="NoResultsComponent" style={{ height: "100vh" }}>
              <Loader height={50} width={50} component={"Notifications"} />
            </div>
          )}
         
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Notifications;
